import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import rules from './plugins/rules'
import VueFlags from '@growthbunker/vueflags'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTheMask from 'vue-the-mask'
import Vue2Filters from 'vue2-filters'
import router from './router'
import store from './store'
// import VueGtm from '@gtm-support/vue2-gtm'
import 'animate.css'

Vue.config.productionTip = false

Vue.use(VueFlags)

Vue.use(rules)

moment.tz.setDefault('America/Punta_Arenas')
moment.locale('es')

Vue.use(VueMoment, {
    moment,
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.use(VueAxios, axios)

Vue.use(VueTheMask)

Vue.use(Vue2Filters)

/* Vue.use(VueGtm, {
  id: 'GTM-PHQ83V2', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
}); */

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
